<template>
  <div id="app" >
    <!-- 导航栏 -->
    <div class="title">
    	<div class="title1">
			    <img src="./assets/img/g_smb.png" alt="">
    	</div>
    	<div class="title2">
          <router-link to="/page" >
            <div :class="flag2=='-1' ? 'pc_box':''" @click="change('-1')" style="margin-left: 0;">首页</div>
          </router-link>
          <router-link to="/center" >
            <div :class="flag2=='2' ? 'pc_box':''" @click="change('2')">产品中心</div>
          </router-link>
          <router-link to="/solution" >
            <div :class="flag2=='3' ? 'pc_box':''" @click="change('3')">解决方案</div>
          </router-link>
          <router-link to="/partner" >
            <div :class="flag2=='4' ? 'pc_box':''" @click="change('4')">合作伙伴</div>
          </router-link>
          <router-link to="/my" >
            <div :class="flag2=='5' ? 'pc_box':''" @click="change('5')">关于我们</div>
          </router-link>
    	</div>
    	<div class="title3" style="font-weight: bold;">
          <div>
    	     免费试用
          </div>
    	</div>
      <div class="payment">
        <div class="pay_wx" @mouseenter="str()" @mouseleave="str()" style="width:96px;position: relative;"><img style="width: 100%;" src="./assets/img/wx.png" alt="">
            <!--二维码 -->
            <div  v-show="flag"  style="background: #FFFFFF; border: 2px solid #4ca669; ">
              <div  class="wx_g1" ></div>
              <div  class="wx_g2" ></div>
              <img style="width: 90%; height: 90%; margin-top: 5%; margin-left: 7%; " src="./assets/img/erm.jpg"  alt="">
            </div>
        </div>
     <!-- <div class="pay_zf"  style="width: 100%;"><img  style="width: 96px;" src="./assets/img/sj.png" alt="">
        </div> -->
        <div class="pay_h" style="width: 100%;">
          <img  style="width: 96px;" src="./assets/img/sj.png" alt="">
        </div>
        <!-- 手机号 -->
        <div  class="pzf"  style="background: rgb(87,112,193); border-radius: 50px;">
          <div class="pzf1">
              <img style="width: 100%; height: 100%;" src="./assets/img/sj.png" alt="">
          </div>
          <div class="pzf2">
              133XXXXXXXX
          </div>
        </div>
      </div>
    </div>

   <!-- 背景图 -->
   <div class="swiper">
     <div class="swiper-big">
       <img src="./assets/img/g_bib.png" alt="">
     </div>
     <!-- <div class="swiper-small">
       <img src="./assets/img/slogo.png" alt="">
     </div> -->
   </div>


    <router-view></router-view>

  </div>
</template>

<script>

export default {
  name: 'App',

  // 移入移除事件
  data(){
        return{
          flag:false,
          flag1:false,
          flag2:'-1'
        }
      },
  methods:{
        str(){
          this.flag = !this.flag
        },
        str1(){
          this.flag1 = !this.flag1
        },
        change(n){
           this.flag2 = n
        }
  },

  // watch:{
  //   $route(newValue,oldValue){
  //   console.log(newValue.path)
  //   console.log(22)
  //   console.log(oldValue.path)
  //       debugger
  //     if(newValue.path == '/partner'){
  //          this.flag2 = '4'
  //     }

  //   }
  // }
}
</script>

<style>
  html{
    font-size:1vw;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* max-width: 1080px; */
  /* overflow: hidden; */
  /* text-align: center; */
  /* color: white; */
}
a{
  text-decoration:none;
  color: #000000;
}
body{
  padding: 0;
  margin: 0;
}

p{
	margin: 0;
	padding: 0;
}
.title{
  padding: 0.08rem 0 ;
  font-size: 0.94rem;
  box-sizing: border-box;
}
.title>div{
	display: inline-block;
	vertical-align: middle;
}
.title1{
	width: 7%;
	margin-left: 6%;
}
.title2{
	width: 48%;
	margin-left: 14%;
}
.title2 div{
	/* background: #000000; */
	width: 14%;
	    /* padding: 5px; */
      margin-left: 6%;
	    height: 38px;
	    line-height: 38px;
	    text-align: center;
	    display: inline-block;
	    vertical-align: middle;
	    border-radius: 10px;
}

.title2 .pc_box{
  background: #FFCE00;
}
.title3{
	    width: 7%;
	    height: 38px;
	    line-height: 38px;
	    text-align: center;
	    margin-left: 11%;
	    border-radius: 10px;
	    border: 2px solid #000000;
}
.title1>img{
	width: 100%;
  height: 113%;
}
/* 背景图 */
.swiper{
  width: 100%;
  position: relative;
}
.swiper-big{
  width: 100%;
}
.swiper-big>img{
  width: 100%;
}
.swiper-small{
  position: absolute;
  right: 23%;
  top: 5%;
  width: 25%;
}
.swiper-small>img{
  width: 100%;
}
.payment{
  position: fixed;
  z-index: 88;
  top: 55%;
  right: 2%;
  width: 5vw;
  height: 18vh;

}

.payment>div:nth-child(1){
 margin-bottom: 18%;
}

.pay_wx>div{
  position: absolute;
  top: 0;
  right:120px;
  z-index: -1;
  width: 300%;
  height: 240px;
  /* height: 104px; */
  /* overflow: hidden; */
}
.pay_wx>div>img{
  width: 100%;
  /* height: 100%; */
}
.pay_wx .wx_g1{
  position: absolute;
  width: 0;
  height: 0;
      border-top: 14px solid transparent;
      border-left: 14px solid #4ca669;
      border-bottom: 14px solid transparent;
      right: -14px;
      top: 14px;
}
.pay_wx .wx_g2{
  position: absolute;
  width: 0;
  height: 0;
      border-top: 11px solid transparent;
      border-left: 11px solid #fff;
      border-bottom: 11px solid transparent;
      right: -11px;
      top: 17px;
}

.pay_h{
      position: absolute;
      top: 119px;
      width: 100%;
      height: 98px;
      z-index: 99;
      /* background: red; */
}
.pay_h:hover img{

  transform: scale(0);
  transition: all .3s ease-in-out .3s;
}
.pay_h:hover+.pzf{
  width: 300px;
  transition: all .3s ease-in-out .3s;
  /* transition: 1s; */
}
.pzf>div{
  display: inline-block;
  vertical-align: middle;
}

.pzf{
  position: absolute;
  height: 98px;
  width: 0;
  text-align: center;
  overflow: hidden;
  /* z-index: -1; */
  top: 119px;
  right: 0px;
  z-index: 2;
}

.pzf1{
      width: 33%;
      position: absolute;
      /* top: -1px; */
      left: 0;
}
.pzf2{
  position: absolute;
      left: 96px;
      top: 36px;
      color: white;
}
/* .pzf>img{
  width: 40%;
  height: 100%;
} */


</style>



// WEBPACK FOOTER //
// src/App.vue